export const onlyDigits = (s: string) => s.replace(/\D/g, "");
export const normalizeDocument = (s: string) => s.toUpperCase().replace(/[^0-9A-Z]/g, "");

/** Só dígitos e a pontuação usual de CPF; qualquer outro caractere invalida (não é descartado). */
const CPF_CHARS = /^[\d.\-\s]+$/;
/** Dígitos, letras (CNPJ alfanumérico) e a pontuação usual de CNPJ. */
const CNPJ_CHARS = /^[0-9A-Za-z.\-/\s]+$/;

export function isValidCPF(input: string): boolean {
  if (!CPF_CHARS.test(input)) return false;
  const d = onlyDigits(input);
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  const calc = (len: number) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += Number(d[i]) * (len + 1 - i);
    const r = (sum * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return calc(9) === Number(d[9]) && calc(10) === Number(d[10]);
}

/** CNPJ numérico e alfanumérico: valor do caractere = código ASCII − 48; DVs sempre numéricos. */
export function isValidCNPJ(input: string): boolean {
  if (!CNPJ_CHARS.test(input)) return false;
  const c = normalizeDocument(input);
  if (!/^[0-9A-Z]{12}\d{2}$/.test(c) || /^(.)\1{13}$/.test(c)) return false;
  const val = (ch: string) => ch.charCodeAt(0) - 48;
  const dv = (len: number) => {
    const weights =
      len === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < len; i++) sum += val(c[i]!) * weights[i]!;
    const r = sum % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return dv(12) === Number(c[12]) && dv(13) === Number(c[13]);
}

export function detectPersonType(doc: string): "F" | "J" | null {
  if (isValidCPF(doc)) return "F";
  if (isValidCNPJ(doc)) return "J";
  return null;
}

export function formatDocument(doc: string): string {
  const c = normalizeDocument(doc);
  if (c.length === 11) return `${c.slice(0, 3)}.${c.slice(3, 6)}.${c.slice(6, 9)}-${c.slice(9)}`;
  if (c.length === 14)
    return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5, 8)}/${c.slice(8, 12)}-${c.slice(12)}`;
  return doc;
}
